module.exports = __webpack_public_path__ + "img/close-white.aef6bb6f.svg";